import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ProjectsPage = () => {
  const projects = [
    {
      title: 'Stamped Concrete Patio',
      location: 'Plano, TX',
      category: 'Concrete',
      description: 'Custom stamped concrete patio with integrated seating wall and decorative borders. Features earth-tone coloring and slate pattern.',
      image: 'https://public.readdy.ai/ai/img_res/a2f6865870ff03c9db2b187735313510.jpg',
    },
    {
      title: 'Screened Porch Addition',
      location: 'Frisco, TX',
      category: 'Outdoor Structures',
      description: 'Full screened porch enclosure with custom lighting, ceiling fans, and composite decking. Dark charcoal frames with white screens.',
      image: 'https://readdy.ai/api/search-image?query=Finished%20screened-in%20porch%20interior%20with%20comfortable%20seating%2C%20warm%20lighting%2C%20ceiling%20fan%2C%20dark%20frames%20with%20white%20screens%2C%20Fort%20Worth%20Texas%20home%2C%20simple%20clean%20setting%2C%20professional%20construction%20photography&width=900&height=700&seq=gallery-porch-1-16&orientation=portrait',
    },
    {
      title: 'Horizontal Cedar Fence',
      location: 'McKinney, TX',
      category: 'Fences',
      description: 'Modern horizontal cedar fence with dark stain finish and matching custom gate. Steel posts for added durability.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20horizontal%20wood%20fence%20with%20dark%20stain%20and%20modern%20design%2C%20custom%20gate%20visible%2C%20Dallas%20Texas%20residential%20yard%2C%20simple%20clean%20background%2C%20professional%20construction%20photography%20showing%20straight%20lines&width=900&height=700&seq=gallery-fence-1-17&orientation=portrait',
    },
    {
      title: 'Decorative Concrete Walkway',
      location: 'Allen, TX',
      category: 'Concrete',
      description: 'Stamped concrete walkway with cobblestone pattern connecting driveway to front entrance. Includes landscape lighting.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20decorative%20stamped%20concrete%20walkway%20with%20cobblestone%20pattern%2C%20landscape%20lighting%2C%20Dallas%20Fort%20Worth%20residential%20property%2C%20simple%20clean%20background%2C%20professional%20construction%20photography%20showing%20detailed%20texture&width=900&height=700&seq=gallery-concrete-2-18&orientation=portrait',
    },
    {
      title: 'Custom Pergola',
      location: 'Prosper, TX',
      category: 'Outdoor Structures',
      description: 'Freestanding pergola with integrated shade system and string lighting. Built with cedar and steel hardware.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20custom%20wooden%20pergola%20with%20integrated%20shade%20system%20and%20string%20lights%2C%20Dallas%20Texas%20backyard%20patio%20setting%2C%20simple%20clean%20background%2C%20professional%20construction%20photography%20showing%20craftsmanship&width=900&height=700&seq=gallery-pergola-1-19&orientation=portrait',
    },
    {
      title: 'Privacy Fence Installation',
      location: 'Richardson, TX',
      category: 'Fences',
      description: 'Traditional vertical board privacy fence with decorative caps and arched gate. Natural cedar finish.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20vertical%20board%20privacy%20fence%20with%20decorative%20caps%20and%20arched%20gate%2C%20natural%20cedar%20wood%20finish%2C%20Dallas%20Texas%20residential%20property%2C%20simple%20clean%20background%2C%20professional%20construction%20photography&width=900&height=700&seq=gallery-fence-2-20&orientation=portrait',
    },
    {
      title: 'Patio Cover Addition',
      location: 'Carrollton, TX',
      category: 'Outdoor Structures',
      description: 'Attached patio cover with composite roofing, recessed lighting, and ceiling fans. Extends living space outdoors.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20attached%20patio%20cover%20with%20composite%20roofing%2C%20recessed%20lighting%2C%20ceiling%20fans%2C%20outdoor%20furniture%20visible%2C%20Dallas%20Fort%20Worth%20home%20exterior%2C%20simple%20clean%20background%2C%20professional%20construction%20photography&width=900&height=700&seq=gallery-patio-cover-21&orientation=portrait',
    },
    {
      title: 'Concrete Driveway',
      location: 'Lewisville, TX',
      category: 'Concrete',
      description: 'New concrete driveway with decorative borders and broom finish. Includes proper drainage and expansion joints.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20concrete%20driveway%20with%20decorative%20borders%20and%20broom%20finish%20texture%2C%20Dallas%20Texas%20residential%20property%2C%20simple%20clean%20background%2C%20professional%20construction%20photography%20showing%20smooth%20surface&width=900&height=700&seq=gallery-concrete-3-22&orientation=portrait',
    },
    {
      title: 'Mudroom Built-Ins',
      location: 'The Colony, TX',
      category: 'Interior',
      description: 'Custom mudroom with built-in bench seating, coat hooks, and storage cubbies. Painted white with dark countertop.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20custom%20mudroom%20interior%20with%20built-in%20bench%20seating%2C%20coat%20hooks%2C%20storage%20cubbies%2C%20white%20painted%20finish%20with%20dark%20countertop%2C%20Dallas%20Texas%20home%20interior%2C%20simple%20clean%20background%2C%20professional%20construction%20photography&width=900&height=700&seq=gallery-interior-1-23&orientation=portrait',
    },
    {
      title: 'Backyard Patio Enclosure',
      location: 'Flower Mound, TX',
      category: 'Outdoor Structures',
      description: 'Complete patio enclosure with screened walls and solid roof. Includes electrical outlets and lighting fixtures.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20backyard%20patio%20enclosure%20with%20screened%20walls%20and%20solid%20roof%2C%20lighting%20fixtures%2C%20comfortable%20outdoor%20furniture%2C%20Fort%20Worth%20Texas%20home%2C%20simple%20clean%20background%2C%20professional%20construction%20photography&width=900&height=700&seq=gallery-enclosure-24&orientation=portrait',
    },
    {
      title: 'Decorative Fence with Gate',
      location: 'Coppell, TX',
      category: 'Fences',
      description: 'Custom decorative fence with horizontal slats and modern gate design. Dark stain with steel accents.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20decorative%20fence%20with%20horizontal%20slats%20and%20modern%20custom%20gate%2C%20dark%20stain%20with%20steel%20accents%2C%20Dallas%20Texas%20residential%20yard%2C%20simple%20clean%20background%2C%20professional%20construction%20photography&width=900&height=700&seq=gallery-fence-3-25&orientation=portrait',
    },
    {
      title: 'Stamped Pool Deck',
      location: 'Grapevine, TX',
      category: 'Concrete',
      description: 'Stamped concrete pool deck with non-slip texture and decorative pattern. Includes integrated drainage system.',
      image: 'https://readdy.ai/api/search-image?query=Completed%20stamped%20concrete%20pool%20deck%20with%20decorative%20pattern%20and%20non-slip%20texture%2C%20Dallas%20Fort%20Worth%20residential%20pool%20area%2C%20simple%20clean%20background%2C%20professional%20construction%20photography%20showing%20detailed%20surface&width=900&height=700&seq=gallery-concrete-4-26&orientation=portrait',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Collection%20of%20completed%20construction%20projects%20showing%20various%20outdoor%20structures%20and%20concrete%20work%2C%20Dallas%20Fort%20Worth%20Texas%20residential%20properties%2C%20professional%20construction%20photography%20montage%2C%20simple%20clean%20backgrounds&width=1920&height=1080&seq=projects-hero-vantex-27&orientation=landscape"
            alt="Vantex Construction Projects"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>

        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 w-full text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6"
          >
            OUR PROJECTS
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-neutral-lighter-gray max-w-3xl mx-auto"
          >
            Real projects from real Dallas-Fort Worth homeowners
          </motion.p>
        </div>
      </section>

      {/* Projects Gallery */}
      <section className="py-20 lg:py-28 bg-neutral-bg-gray">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <motion.div
                key={project.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: (index % 3) * 0.1 }}
                className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
              >
                <div className="relative h-80">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-primary-red text-white px-3 py-1 text-xs font-bold tracking-wide whitespace-nowrap">
                      {project.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-neutral-charcoal mb-2">
                    {project.title}
                  </h3>
                  <div className="flex items-center text-neutral-gray mb-4">
                    <i className="ri-map-pin-line mr-2 text-primary-red w-4 h-4 flex items-center justify-center"></i>
                    <span className="text-sm">{project.location}</span>
                  </div>
                  <p className="text-neutral-gray leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-neutral-black py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            YOUR PROJECT COULD BE NEXT
          </h2>
          <p className="text-xl text-neutral-light-gray mb-10 max-w-2xl mx-auto">
            Let's discuss your construction project and create something exceptional
          </p>
          <Link
            to="/quote"
            className="inline-flex items-center bg-primary-red hover:bg-primary-red-dark text-white px-10 py-5 font-bold text-lg tracking-wide transition-colors whitespace-nowrap cursor-pointer"
          >
            REQUEST FREE ESTIMATE
            <i className="ri-arrow-right-line ml-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProjectsPage;